import React from 'react';
import PropTypes from 'prop-types';
import { Navbar, Image, Nav, MenuItem, Button } from 'react-bootstrap';
import { withRouter } from 'react-router';

import { PROFILE_MENU } from '../core/MenuComponent/MenuConstants';
import DropDownComponent from '../core/DropDownComponent/DropDownComponent';
import { LANDING_PATH, HOME_PATH, DOCUMENTATION_PATH, SIGN_UP_PATH, SIGN_IN_PATH, USECASES_PATH, LICENSES_PATH, SUPPORT_PATH, PROFILE_PATH, OVERVIEW_PATH, ADMIN_PATH, GUIDES_PATH } from '../../constants/routes';
import CONFIG from '../../config/config';
//import { MEMBER_ROLES } from '../../constants/common';
//import LinkComponent from '../../components/core/LinkComponent/LinkComponent';

import './header.scss';

const logo = require('./halo-logo-beta.png');

const PROFILE = {
    ...PROFILE_MENU,
    'api-documentation': {
        title: 'Documentation',
        url: OVERVIEW_PATH,
    },
    /*company: {
        title: 'Company',
        url: HOME_PATH,
        //accessDenied: [MEMBER_ROLES.admin, MEMBER_ROLES.member],
    },*/
    logOut: {
        title: 'Log Out',
        url: LANDING_PATH,
    },
};

class HeaderComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            items: [],
        };
    }

    componentWillMount() {
        const items = [];

        Object.keys(PROFILE).forEach((path) => {
            const { title, url } = PROFILE[path];

            items.push({
                title,
                url: url || '/profile/' + path,
                //companyRequired,
                //accessDenied,
            });
        });

        this.setState({ items });
    }

    render() {
        const { items } = this.state;
        const { history, location: { pathname: path }, user, logout, isEntryPoint } = this.props;
        const isLandingPage = path === LANDING_PATH;
        const isSignInPage = path === SIGN_IN_PATH;
        const isSignUpPage = path === SIGN_UP_PATH;
        const goToSignUpPage = () => this.props.history.push(SIGN_UP_PATH, { prevPath: LANDING_PATH })
        const goToSignInPage = () => this.props.history.push(SIGN_IN_PATH, { prevPath: LANDING_PATH })
        const goToHomePage = () => this.props.history.push(HOME_PATH, { prevPath: LANDING_PATH })
        const goToLandingPage = () => this.props.history.push(LANDING_PATH, { prevPath: LANDING_PATH })
        const goToUsecasesPage = () => this.props.history.push(USECASES_PATH, { prevPath: LANDING_PATH })
        const goToDocumentationPage = () => this.props.history.push(OVERVIEW_PATH, { prevPath: LANDING_PATH })
        const goToLicensesPage = () => this.props.history.push(LICENSES_PATH, { prevPath: LANDING_PATH })
        const goToGuidesPage = () => this.props.history.push(GUIDES_PATH, { prevPath: LANDING_PATH })
        const goToSupportPage = () => this.props.history.push(SUPPORT_PATH, { prevPath: LANDING_PATH })
        const goToAdminPage = () => this.props.history.push(ADMIN_PATH, { prevPath: LANDING_PATH })
        var page = '/' + window.location.pathname.split('/')[1];
        if (page === PROFILE_PATH) {
            page += '/' + window.location.pathname.split('/')[2];
        }

        return <div id="header" className={`Header-component ${path.indexOf('api') > -1 && 'sticky'}`}>
            {/* {!isEntryPoint && <div className={`top ${!isLandingPage && 'help'}`}>
                {isLandingPage
                    ? <span>New site coming soon!
                        &nbsp;<LinkComponent url={SIGN_UP_PATH} title="Sign Up" />&nbsp;
                        now for early access.</span>
                    : <span>Need Help? Contact Us</span>
                }
            </div>} */}
            <Navbar className={(isLandingPage || isSignInPage || isSignUpPage) ? 'initialPage' : ''}>
                <Navbar.Header className="haloLogoCursor">
                    {user
                        ? <Navbar.Brand>
                            <Image src={logo} onClick={goToHomePage} />
                            {/* <Image src={logo} /> */}
                        </Navbar.Brand>
                        : <Navbar.Brand>
                            <Image src={logo} onClick={goToLandingPage} />
                            {/* <Image src={logo} /> */}
                        </Navbar.Brand>
                    }
                    <Navbar.Toggle />
                </Navbar.Header>
                <Nav className="center-actions">
                    <span className={page === USECASES_PATH ? 'underline' : ''} onClick={goToUsecasesPage}>Use Cases</span>
                    <span className={page === DOCUMENTATION_PATH ? 'underline' : ''} onClick={goToDocumentationPage}>Docs</span>
                    {user && <span className={page === LICENSES_PATH ? 'underline' : ''} onClick={goToLicensesPage}>Licenses</span>}
                    <a href={CONFIG.restURL} target="_blank"><span>Sandbox</span></a>
                    <span className={page === GUIDES_PATH ? 'underline' : ''} onClick={goToGuidesPage}>Guides</span>
                    {user && <span className={page === SUPPORT_PATH ? 'underline' : ''} onClick={goToSupportPage}>Support</span>}
                    {user && user.admin && <span className={page === ADMIN_PATH ? 'underline' : ''} onClick={goToAdminPage}>Admin</span>}
                </Nav>
                {!isLandingPage && !isEntryPoint && user
                    ? <Navbar.Collapse>
                        <Nav pullRight className="right-actions">
                            {/*<DropDownComponent
                            className="docs"
                            eventKey={1}
                            title="Docs"
                            id="docs-dropdown"
                        >
                            <MenuItem eventKey={1.2}>Android</MenuItem>
                            <MenuItem eventKey={1.3}>IOS</MenuItem>
                        </DropDownComponent>
                        <NavItem className="search" eventKey={2} href="#">
                            <span className="search-icon" />
                        </NavItem>*/}
                            <DropDownComponent
                                eventKey={3}
                                title={<span className="profile">
                                    <span className="profile-icon" />
                                    Welcome, {`${user.firstName}`}
                                </span>}
                                id="profile-dropdown"
                                className="profile-dropdown"
                            >
                                {items.map(({ accessDenied, url, title }, index) =>
                                    <MenuItem
                                        key={index}
                                        eventKey={'3.' + (index + 1)}
                                        onSelect={() => url === LANDING_PATH ? logout() : history.push(url)}
                                    >{title}</MenuItem>
                                )}
                            </DropDownComponent>
                        </Nav>
                    </Navbar.Collapse>
                    : <div className="login-signup-buttons">
                        { !isSignInPage && !isSignUpPage && <Button onClick={goToSignUpPage}>Sign Up</Button>}
                        { !isSignInPage && !isSignUpPage && <span>&nbsp;&nbsp;</span> }
                        { !isSignInPage && !isSignUpPage && <Button onClick={goToSignInPage} className="dark">Log In</Button>}
                        { isSignInPage && <Button className="signInUpPageOnly" onClick={goToSignUpPage}>Sign Up Now</Button>}
                        { isSignUpPage && <Button className="signInUpPageOnly" onClick={goToSignInPage}>Log In</Button>}
                    </div>
                }
            </Navbar>
        </div>;
    }
}

HeaderComponent.defaultProps = {
    isEntryPoint: false,
};

HeaderComponent.propTypes = {
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    user: PropTypes.object,
    logout: PropTypes.func,
    isEntryPoint: PropTypes.bool,
};

export default withRouter(HeaderComponent);



// WEBPACK FOOTER //
// ./src/components/header/HeaderComponent.js